import type { ComponentType } from 'react';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { IdentityEmailField } from './IdentityEmailField';

export const IdentityEmailFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'IdentityEmail',
    component: IdentityEmailField,
  }),
) as unknown as ComponentType;
